import React from 'react';
import { Vector3 } from 'three';

import { AnalogJoint } from '@paragon/contract-library';
import { isLoggedInUserEngineer, isLoggedInUserRoot } from '@paragon/login-tools';

import { useAppDispatch, useAppSelector } from '../../components/hooks';
import { shiftAnalogJointPosition } from '../../store/actions/editAnalogModelActions';
import { getCurrentCoordinateDirection } from '../../store/selectors/getCurrentCoordinateDirectionSelector';
import { NudgeHandle } from './NudgeHandle';

export const AnalogJointEditorHandle = ({ analogJoint }: { analogJoint: AnalogJoint }) => {
  const dispatch = useAppDispatch();

  const activeComponentDesignGuid = useAppSelector((state) => state.selections.activeComponentDesignGuid)!;
  const isRootUser = useAppSelector(isLoggedInUserRoot);
  const isEngineerUser = useAppSelector(isLoggedInUserEngineer);
  const canEditAnalogJoints = isRootUser || isEngineerUser;
  const coordinateUpDirection = useAppSelector(getCurrentCoordinateDirection);

  if (!canEditAnalogJoints) return null;

  const { x, y, z } = analogJoint;
  const position = new Vector3(x, y, z);
  return (
    <NudgeHandle
      editType="EditingAnalogJoint"
      leftRight
      topBottom
      moveCallback={(deltaX: number, deltaY: number) =>
        dispatch(shiftAnalogJointPosition(activeComponentDesignGuid, analogJoint.guid, deltaX, deltaY, 0))
      }
      position={position}
      size={0.8}
      coordinateUpDirection={coordinateUpDirection}
      settingsButton={{ type: 'FullTransform', position: { x: 1, y: 1, z: 0 } }}
    />
  );
};
